export function isSupportedConfig(config) {
    return config.advertResourceList[0].type === 'PIC' || config.advertResourceList[0].type === 'CUSTOM';
}
export const getImageUrl = (config) => {
    const resource = config.advertResourceList[0];
    if (resource.type === 'PIC') {
        return resource.content.image[0].url || '';
    }
    if (resource.type === 'CUSTOM') {
        return resource.content.images[0].url || '';
    }
    return '';
};
export const getBgColor = (config) => config.advertResourceList[0].bgColor;
